export const INSURANCES_GET_REQUESTING = 'INSURANCES_GET_REQUESTING';
export const INSURANCES_GET_SUCCESS = 'INSURANCES_GET_SUCCESS';
export const INSURANCES_GET_ERROR = 'INSURANCES_GET_ERROR';